import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const promises = ['Línea Herrero + Módena + A30 con DVH', 'Fórmulas de corte y descuento exactas', 'Presupuestador anti-inflación', 'Scripts de WhatsApp que cierran trabajos', 'Checklist de medición + instalación profesional'];
export function PromiseSection() {
  return <section className="py-12 bg-matte text-white border-y-4 border-gold" data-id="element-142">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-10" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4 leading-tight" data-id="element-145">
            Con este sistema, tu próximo trabajo sale perfecto —{' '}
            <span className="text-gold" data-id="element-146">y lo cobrás bien.</span>
          </h2>
        </motion.div>

        <div className="flex flex-col md:flex-row items-center gap-8 bg-white/5 border border-silver/10 p-6 md:p-8 shadow-xl" data-id="element-147">
          <div className="w-full md:w-1/3 flex justify-center" data-id="element-148">
            <img src="https://cdn.magicpatterns.com/uploads/geeQnDy3wQMCydhKCmLHyU/private_openrouter-generated-image-1776135192283.png" alt="Super Combo Carpintería en Aluminio" className="w-48 md:w-full h-auto drop-shadow-lg" data-id="element-149" />
          </div>

          <div className="w-full md:w-2/3" data-id="element-150">
            <h3 className="text-2xl font-black text-gold mb-2" data-id="element-151">
              SUPER COMBO CARPINTERÍA EN ALUMINIO
            </h3>
            <p className="text-lg font-medium text-silver mb-6 leading-snug" data-id="element-152">
              6 Tomos técnicos + 6 Bonos exclusivos. 480 páginas de sistema
              probado para el mercado argentino.
            </p>

            <div className="space-y-3" data-id="element-153">
              {promises.map((promise, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.05
            }} className="flex items-center" data-id="element-154">
                  <Check className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-155" />
                  <p className="text-base font-bold text-white" data-id="element-156">{promise}</p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}